module.exports = ".login-page {\n  margin-top: 100px; }\n\n.error {\n  margin: 10px 0;\n  color: red; }\n"